import _ from "lodash";
import CONFIG from "../../../config/config";

const BLOCK_TYPES = {
    AI_ASSISTANT: "AI_ASSISTANT",
    START_POINT: "START_POINT",
    BOT_RESPONSE: "BOT_RESPONSE",
    AI_BOT_RESPONSE: "AI_BOT_RESPONSE",
    AI_CLASSIFICATION: "AI_CLASSIFICATION",
    DEFAULT_FALLBACK: "DEFAULT_FALLBACK",
    DEFAULT_TIMEOUT: "DEFAULT_TIMEOUT",
    AI_FUNCTIONS: "AI_FUNCTIONS",
    FALLBACK: "FALLBACK",
    TIMEOUT: "TIMEOUT",
    FILTER: "FILTER",
    FLOW: "FLOW",
    ATTACHMENT_INPUT: "ATTACHMENT_INPUT",
    USER_INPUT: "USER_INPUT",
    GO_TO_STEP: "GO_TO_STEP",
    ADD_TO_SEGMENT: "ADD_TO_SEGMENT",
    REMOVE_FROM_SEGMENT: "REMOVE_FROM_SEGMENT",
    WEBHOOK: "WEBHOOK",
    API_REQUEST: "API_REQUEST",
    SET_ATTRIBUTE: "SET_ATTRIBUTE",
    QUESTION: "QUESTION",
    CLOSE_CHAT: "CLOSE_CHAT",
    CREATE_TICKET: "CREATE_TICKET",
    TRANSFER_CHAT: "TRANSFER_CHAT",
    TRANSFER_TO_CHATBOT: "TRANSFER_TO_CHATBOT",
    TAG_CHAT: "TAG_CHAT",
    REMOVE_TAG: "REMOVE_TAG",
    SET_DEPARTMENT: "SET_DEPARTMENT",
    SEND_TRANSCRIPT: "SEND_TRANSCRIPT",
    SUCCESS: "SUCCESS",
    FAILURE: "FAILURE",
    GET_LOCATION: "GET_LOCATION",
    SHOPIFY_SHOW_PRODUCTS: "SHOPIFY_SHOW_PRODUCTS",
    SHOPIFY_PRODUCT_AVAILABILITY: "SHOPIFY_PRODUCT_AVAILABILITY",
    SHOPIFY_ORDER_STATUS: "SHOPIFY_ORDER_STATUS",

    AKINON_SHOW_PRODUCTS: "AKINON_SHOW_PRODUCTS",
    AKINON_ORDER_STATUS: "AKINON_ORDER_STATUS",
    AKINON_SELECT_ORDER: "AKINON_SELECT_ORDER",
    AKINON_FIND_NEAREST_STOCK: "AKINON_FIND_NEAREST_STOCK",
    AKINON_FIND_PRODUCT: "AKINON_FIND_PRODUCT",
    AKINON_SELECT_SIZE: "AKINON_SELECT_SIZE",
    AKINON_SHOW_DISCOUNT_CODES: "AKINON_SHOW_DISCOUNT_CODES",
    AKINON_FIND_NEAREST_STORES: "AKINON_FIND_NEAREST_STORES",

    IDEASOFT_SELECT_ORDER: "IDEASOFT_SELECT_ORDER",
    IDEASOFT_ORDER_STATUS: "IDEASOFT_ORDER_STATUS",
    IDEASOFT_GET_MEMBER_INFO: "IDEASOFT_GET_MEMBER_INFO",
    IDEASOFT_PRODUCT_SEARCH: "IDEASOFT_PRODUCT_SEARCH",

    PROBEL_SELECT_BRANCH: "PROBEL_SELECT_BRANCH",
    PROBEL_SELECT_CLINIC: "PROBEL_SELECT_CLINIC",
    PROBEL_SELECT_DAY: "PROBEL_SELECT_DAY",
    PROBEL_SELECT_HOUR: "PROBEL_SELECT_HOUR",
    PROBEL_MAKE_APPOINTMENT: "PROBEL_MAKE_APPOINTMENT",
    PROBEL_CANCEL_APPOINTMENT: "PROBEL_CANCEL_APPOINTMENT",
    PROBEL_GET_PATIENT_TOKEN: "PROBEL_GET_PATIENT_TOKEN",
    PROBEL_FILL_INFO: "PROBEL_FILL_INFO",
    PROBEL_SELECT_APPOINTMENT: "PROBEL_SELECT_APPOINTMENT",

    CREATE_RESERVATION: "CREATE_RESERVATION",
    RESERVATION_SELECT_DAY: "RESERVATION_SELECT_DAY",
    RESERVATION_SELECT_TIME: "RESERVATION_SELECT_TIME",
    RESERVATION_OPEN_URL: "RESERVATION_OPEN_URL",
    RESERVATION_EVENT_LIST: "RESERVATION_EVENT_LIST",

    SEND_SMS: "SEND_SMS",
    SEND_MAIL: "SEND_MAIL",
    CREATE_EVENT: "CREATE_EVENT",
    CREATE_TASK: "CREATE_TASK",

    SUPPRESSION_ADD: "SUPPRESSION_ADD",
    SUPPRESSION_REMOVE: "SUPPRESSION_REMOVE",

    B2CARGO_LOGIN_USER: "B2CARGO_LOGIN_USER",
    B2CARGO_PRODUCT_STATUS: "B2CARGO_PRODUCT_STATUS",
    SEND_WP_BUSINESS_MESSAGE: "SEND_WP_BUSINESS_MESSAGE",

    AI_MENU_FLOW: "AI_MENU_FLOW",
    OTP_WHATSAPP_FLOW: "OTP_WHATSAPP_FLOW",
    OTP_MAIL_FLOW: "OTP_MAIL_FLOW",
    OTP_SMS_FLOW: "OTP_SMS_FLOW",
    AI_INSTAGRAM_FLOW: "AI_INSTAGRAM_FLOW",
    PLATFORM_FLOW: "PLATFORM_FLOW",

    MESSENGER_SEND_MESSAGE: "MESSENGER_SEND_MESSAGE",
    INSTAGRAM_SEND_MESSAGE: "INSTAGRAM_SEND_MESSAGE",
    INSTAGRAM_COMMENT_REPLY: "INSTAGRAM_COMMENT_REPLY",
    INSTAGRAM_COMMENT_DELETE: "INSTAGRAM_COMMENT_DELETE",
    INSTAGRAM_COMMENT_SHOW: "INSTAGRAM_COMMENT_SHOW",
    INSTAGRAM_COMMENT_HIDE: "INSTAGRAM_COMMENT_HIDE",
    INSTAGRAM_COMMENT_REPLY_AS_PRIVATE: "INSTAGRAM_COMMENT_REPLY_AS_PRIVATE",

    HOLIDAY_PLUS_GET_HOTELS: "HOLIDAY_PLUS_GET_HOTELS",
    HOLIDAY_PLUS_GET_ROOMS: "HOLIDAY_PLUS_GET_ROOMS",

    TABLE_CREATE_RECORD: "TABLE_CREATE_RECORD",
    TABLE_DELETE_RECORD: "TABLE_DELETE_RECORD",
    TABLE_UPDATE_RECORD: "TABLE_UPDATE_RECORD",
    TABLE_FIND_RECORD: "TABLE_FIND_RECORD",
    TABLE_FIND_RECORDS: "TABLE_FIND_RECORDS",

    ZOHO_CREATE_RECORD: "ZOHO_CREATE_RECORD",

    FEEDBACK_AI_ASSISTANT: "FEEDBACK_AI_ASSISTANT",

    ASSIGN_OWNER: "ASSIGN_OWNER",

    TAVILY_WEB_SEARCH: "TAVILY_WEB_SEARCH",
    OPENAI_WEB_SEARCH: "OPENAI_WEB_SEARCH",

    TSOFT_ORDER_STATUS: "TSOFT_ORDER_STATUS",
    TSOFT_SELECT_ORDER: "TSOFT_SELECT_ORDER",
    TICIMAX_V2_ORDER_STATUS: "TICIMAX_V2_ORDER_STATUS",
    TICIMAX_V2_SELECT_ORDER: "TICIMAX_V2_SELECT_ORDER",

    AI_CALL: "AI_CALL",

    IKAS_GET_MEMBER_INFO: "IKAS_GET_MEMBER_INFO",
    IKAS_SELECT_ORDER: "IKAS_SELECT_ORDER",
    IKAS_ORDER_STATUS: "IKAS_ORDER_STATUS",

    INSERT_TO_SYSTEM_PROMPT: "INSERT_TO_SYSTEM_PROMPT",

    META_SEND_CAPI_EVENT: "META_SEND_CAPI_EVENT",
    
    RUN_JAVASCRIPT: "RUN_JAVASCRIPT",
    
    CACHE_WRITE: "CACHE_WRITE",
    CACHE_READ: "CACHE_READ",
    CACHE_EXTEND: "CACHE_EXTEND",
    CACHE_DELETE: "CACHE_DELETE",
    
    CUSTOM_BLOCK: "CUSTOM_BLOCK",
};
if (!CONFIG.AKINON.enabled) {
    delete BLOCK_TYPES.AKINON_SHOW_PRODUCTS;
    delete BLOCK_TYPES.AKINON_ORDER_STATUS;
    delete BLOCK_TYPES.AKINON_SELECT_ORDER;
    delete BLOCK_TYPES.AKINON_FIND_NEAREST_STOCK;
    delete BLOCK_TYPES.AKINON_FIND_PRODUCT;
    delete BLOCK_TYPES.AKINON_SELECT_SIZE;
    delete BLOCK_TYPES.AKINON_SHOW_DISCOUNT_CODES;
    delete BLOCK_TYPES.AKINON_FIND_NEAREST_STORES;
}

if (!CONFIG.B2CARGO.enabled) {
    delete BLOCK_TYPES.B2CARGO_LOGIN_USER;
    delete BLOCK_TYPES.B2CARGO_PRODUCT_STATUS;
}

if (!CONFIG.HOLIDAY_PLUS.enabled) {
    delete BLOCK_TYPES.HOLIDAY_PLUS_GET_ROOMS;
    delete BLOCK_TYPES.HOLIDAY_PLUS_GET_HOTELS;
}

if (!CONFIG.PROBEL.enabled) {
    delete BLOCK_TYPES.PROBEL_SELECT_BRANCH;
    delete BLOCK_TYPES.PROBEL_SELECT_CLINIC;
    delete BLOCK_TYPES.PROBEL_SELECT_DAY;
    delete BLOCK_TYPES.PROBEL_SELECT_HOUR;
    delete BLOCK_TYPES.PROBEL_MAKE_APPOINTMENT;
    delete BLOCK_TYPES.PROBEL_CANCEL_APPOINTMENT;
    delete BLOCK_TYPES.PROBEL_GET_PATIENT_TOKEN;
    delete BLOCK_TYPES.PROBEL_FILL_INFO;
    delete BLOCK_TYPES.PROBEL_SELECT_APPOINTMENT;
}
if (!CONFIG.CHATBOT.GPT3_ENABLED) {
    delete BLOCK_TYPES.AI_BOT_RESPONSE;
}
BLOCK_TYPES.ALL_BLOCKS = Object.keys(BLOCK_TYPES).map((key) => BLOCK_TYPES[key]);

BLOCK_TYPES.TERMINATION_BLOCKS = [
    BLOCK_TYPES.CLOSE_CHAT,
    BLOCK_TYPES.TRANSFER_CHAT,
    BLOCK_TYPES.GO_TO_STEP,
    BLOCK_TYPES.TRANSFER_TO_CHATBOT,
    BLOCK_TYPES.FEEDBACK_AI_ASSISTANT,

];
BLOCK_TYPES.MULTI_CHILD_BLOCKS = [
    BLOCK_TYPES.QUESTION,
    BLOCK_TYPES.WEBHOOK,
    BLOCK_TYPES.API_REQUEST,
    BLOCK_TYPES.SHOPIFY_SHOW_PRODUCTS,
    BLOCK_TYPES.SHOPIFY_PRODUCT_AVAILABILITY,
    BLOCK_TYPES.SHOPIFY_ORDER_STATUS,
    BLOCK_TYPES.AKINON_SHOW_PRODUCTS,
    BLOCK_TYPES.AKINON_ORDER_STATUS,
    BLOCK_TYPES.AKINON_SELECT_ORDER,
    BLOCK_TYPES.AKINON_FIND_NEAREST_STOCK,
    BLOCK_TYPES.AKINON_FIND_PRODUCT,
    BLOCK_TYPES.AKINON_SELECT_SIZE,
    BLOCK_TYPES.PROBEL_SELECT_BRANCH,
    BLOCK_TYPES.PROBEL_SELECT_CLINIC,
    BLOCK_TYPES.PROBEL_SELECT_DAY,
    BLOCK_TYPES.PROBEL_SELECT_HOUR,
    BLOCK_TYPES.PROBEL_MAKE_APPOINTMENT,
    BLOCK_TYPES.PROBEL_CANCEL_APPOINTMENT,
    BLOCK_TYPES.PROBEL_GET_PATIENT_TOKEN,
    BLOCK_TYPES.PROBEL_FILL_INFO,
    BLOCK_TYPES.PROBEL_SELECT_APPOINTMENT,
    BLOCK_TYPES.IDEASOFT_SELECT_ORDER,
    BLOCK_TYPES.IDEASOFT_ORDER_STATUS,
    BLOCK_TYPES.IDEASOFT_GET_MEMBER_INFO,
    BLOCK_TYPES.IDEASOFT_PRODUCT_SEARCH,
    BLOCK_TYPES.CREATE_EVENT,
    BLOCK_TYPES.CREATE_RESERVATION,
    BLOCK_TYPES.RESERVATION_OPEN_URL,
    BLOCK_TYPES.RESERVATION_SELECT_DAY,
    BLOCK_TYPES.RESERVATION_SELECT_TIME,
    BLOCK_TYPES.RESERVATION_EVENT_LIST,
    BLOCK_TYPES.B2CARGO_LOGIN_USER,
    BLOCK_TYPES.B2CARGO_PRODUCT_STATUS,
    BLOCK_TYPES.SEND_WP_BUSINESS_MESSAGE,
    BLOCK_TYPES.ZOHO_CREATE_RECORD,
    BLOCK_TYPES.MESSENGER_SEND_MESSAGE,
    BLOCK_TYPES.INSTAGRAM_SEND_MESSAGE,
    BLOCK_TYPES.TAVILY_WEB_SEARCH,
    BLOCK_TYPES.OPENAI_WEB_SEARCH,
    BLOCK_TYPES.TSOFT_ORDER_STATUS,
    BLOCK_TYPES.TICIMAX_V2_SELECT_ORDER,
    BLOCK_TYPES.TICIMAX_V2_ORDER_STATUS,
    BLOCK_TYPES.AI_CALL,
    BLOCK_TYPES.IKAS_SELECT_ORDER,
    BLOCK_TYPES.IKAS_ORDER_STATUS,
    BLOCK_TYPES.META_SEND_CAPI_EVENT,
];
BLOCK_TYPES.INPUT_BLOCKS = [BLOCK_TYPES.USER_INPUT, BLOCK_TYPES.ATTACHMENT_INPUT];
BLOCK_TYPES.MAIN_RESTRICT_BLOCKS = [
    BLOCK_TYPES.GO_TO_STEP,
    BLOCK_TYPES.CLOSE_CHAT,
    BLOCK_TYPES.QUESTION,
    BLOCK_TYPES.WEBHOOK,
    BLOCK_TYPES.API_REQUEST,
];
BLOCK_TYPES.SPECIAL_BLOCKS = [
    BLOCK_TYPES.AKINON_SHOW_PRODUCTS,
    BLOCK_TYPES.AKINON_ORDER_STATUS,
    BLOCK_TYPES.AKINON_SELECT_ORDER,
    BLOCK_TYPES.AKINON_FIND_NEAREST_STOCK,
    BLOCK_TYPES.AKINON_FIND_NEAREST_STORES,
    BLOCK_TYPES.AKINON_FIND_PRODUCT,
    BLOCK_TYPES.AKINON_SELECT_SIZE,
    BLOCK_TYPES.AKINON_SHOW_DISCOUNT_CODES,
    BLOCK_TYPES.SHOPIFY_SHOW_PRODUCTS,
    BLOCK_TYPES.SHOPIFY_PRODUCT_AVAILABILITY,
    BLOCK_TYPES.SHOPIFY_ORDER_STATUS,
    BLOCK_TYPES.PROBEL_SELECT_BRANCH,
    BLOCK_TYPES.PROBEL_SELECT_CLINIC,
    BLOCK_TYPES.PROBEL_SELECT_DAY,
    BLOCK_TYPES.PROBEL_SELECT_HOUR,
    BLOCK_TYPES.PROBEL_MAKE_APPOINTMENT,
    BLOCK_TYPES.PROBEL_CANCEL_APPOINTMENT,
    BLOCK_TYPES.PROBEL_GET_PATIENT_TOKEN,
    BLOCK_TYPES.PROBEL_FILL_INFO,
    BLOCK_TYPES.PROBEL_SELECT_APPOINTMENT,
    BLOCK_TYPES.IDEASOFT_SELECT_ORDER,
    BLOCK_TYPES.IDEASOFT_ORDER_STATUS,
    BLOCK_TYPES.IDEASOFT_GET_MEMBER_INFO,
    BLOCK_TYPES.IDEASOFT_PRODUCT_SEARCH,
    BLOCK_TYPES.ZOHO_CREATE_RECORD,
    BLOCK_TYPES.TSOFT_ORDER_STATUS,
    BLOCK_TYPES.TICIMAX_V2_SELECT_ORDER,
    BLOCK_TYPES.TICIMAX_V2_ORDER_STATUS,
    BLOCK_TYPES.IKAS_GET_MEMBER_INFO,
    BLOCK_TYPES.IKAS_SELECT_ORDER,
    BLOCK_TYPES.IKAS_ORDER_STATUS,
];
BLOCK_TYPES.AKINON_BLOCKS = [
    BLOCK_TYPES.AKINON_SHOW_PRODUCTS,
    BLOCK_TYPES.AKINON_ORDER_STATUS,
    BLOCK_TYPES.AKINON_SELECT_ORDER,
    BLOCK_TYPES.AKINON_FIND_NEAREST_STOCK,
    BLOCK_TYPES.AKINON_FIND_PRODUCT,
    BLOCK_TYPES.AKINON_SELECT_SIZE,
    BLOCK_TYPES.AKINON_SHOW_DISCOUNT_CODES,
    BLOCK_TYPES.AKINON_FIND_NEAREST_STORES,
];
BLOCK_TYPES.PROBEL_BLOCKS = [
    BLOCK_TYPES.PROBEL_SELECT_BRANCH,
    BLOCK_TYPES.PROBEL_SELECT_CLINIC,
    BLOCK_TYPES.PROBEL_SELECT_DAY,
    BLOCK_TYPES.PROBEL_SELECT_HOUR,
    BLOCK_TYPES.PROBEL_MAKE_APPOINTMENT,
    BLOCK_TYPES.PROBEL_CANCEL_APPOINTMENT,
    BLOCK_TYPES.PROBEL_GET_PATIENT_TOKEN,
    BLOCK_TYPES.PROBEL_FILL_INFO,
    BLOCK_TYPES.PROBEL_SELECT_APPOINTMENT,
];
BLOCK_TYPES.IDEASOFT_BLOCKS = [
    BLOCK_TYPES.IDEASOFT_SELECT_ORDER,
    BLOCK_TYPES.IDEASOFT_ORDER_STATUS,
    BLOCK_TYPES.IDEASOFT_GET_MEMBER_INFO,
    BLOCK_TYPES.IDEASOFT_PRODUCT_SEARCH,
];
BLOCK_TYPES.TSOFT_BLOCKS = [
    BLOCK_TYPES.TSOFT_ORDER_STATUS,
    BLOCK_TYPES.TSOFT_SELECT_ORDER,
];
BLOCK_TYPES.TICIMAX_V2_BLOCKS = [
    BLOCK_TYPES.TICIMAX_V2_SELECT_ORDER,
    BLOCK_TYPES.TICIMAX_V2_ORDER_STATUS,
];
BLOCK_TYPES.SHOPIFY_BLOCKS = [
    BLOCK_TYPES.SHOPIFY_SHOW_PRODUCTS,
    BLOCK_TYPES.SHOPIFY_PRODUCT_AVAILABILITY,
    BLOCK_TYPES.SHOPIFY_ORDER_STATUS,
];

BLOCK_TYPES.B2CARGO_BLOCKS = [BLOCK_TYPES.B2CARGO_LOGIN_USER, BLOCK_TYPES.B2CARGO_PRODUCT_STATUS];
BLOCK_TYPES.TAILED_FLOW_BLOCKS = [
    BLOCK_TYPES.AI_MENU_FLOW,
    BLOCK_TYPES.OTP_MAIL_FLOW,
    BLOCK_TYPES.OTP_WHATSAPP_FLOW,
    BLOCK_TYPES.OTP_SMS_FLOW,
    BLOCK_TYPES.AI_INSTAGRAM_FLOW,
    BLOCK_TYPES.PLATFORM_FLOW,
];

BLOCK_TYPES.IKAS_BLOCKS = [
    BLOCK_TYPES.IKAS_GET_MEMBER_INFO,
    BLOCK_TYPES.IKAS_SELECT_ORDER,
    BLOCK_TYPES.IKAS_ORDER_STATUS,
];

const isElseIfBlockPattern = (block, sourceType) => {
    block = _.cloneDeep(block);
    const validPatterns = [
        [BLOCK_TYPES.FALLBACK],
        [BLOCK_TYPES.FILTER],
        [BLOCK_TYPES.FILTER, BLOCK_TYPES.FALLBACK],
        [BLOCK_TYPES.ADD_TO_SEGMENT],
        [BLOCK_TYPES.REMOVE_FROM_SEGMENT],
        [BLOCK_TYPES.USER_INPUT],
        [BLOCK_TYPES.ATTACHMENT_INPUT],
        [BLOCK_TYPES.TIMEOUT],
        [BLOCK_TYPES.FALLBACK, BLOCK_TYPES.TIMEOUT],
        [BLOCK_TYPES.USER_INPUT, BLOCK_TYPES.TIMEOUT],
        [BLOCK_TYPES.USER_INPUT, BLOCK_TYPES.FALLBACK],
        [BLOCK_TYPES.USER_INPUT, BLOCK_TYPES.FALLBACK, BLOCK_TYPES.TIMEOUT],
        [BLOCK_TYPES.ATTACHMENT_INPUT, BLOCK_TYPES.TIMEOUT],
        [BLOCK_TYPES.ATTACHMENT_INPUT, BLOCK_TYPES.FALLBACK],
        [BLOCK_TYPES.ATTACHMENT_INPUT, BLOCK_TYPES.FALLBACK, BLOCK_TYPES.TIMEOUT],
        [BLOCK_TYPES.USER_INPUT, BLOCK_TYPES.ATTACHMENT_INPUT],
        [BLOCK_TYPES.USER_INPUT, BLOCK_TYPES.ATTACHMENT_INPUT, BLOCK_TYPES.TIMEOUT],
        [BLOCK_TYPES.USER_INPUT, BLOCK_TYPES.ATTACHMENT_INPUT, BLOCK_TYPES.FALLBACK],
        [BLOCK_TYPES.USER_INPUT, BLOCK_TYPES.ATTACHMENT_INPUT, BLOCK_TYPES.FALLBACK, BLOCK_TYPES.TIMEOUT],
    ].map((arr) => _.orderBy(arr, (q) => q, ["asc"]));
    const currentPattern = _.chain(
        _.concat(
            block.children.map((child) => child.type),
            [sourceType]
        )
    )
        .uniq()
        .orderBy((q) => q, ["asc"])
        .value();
    const isValid = _.some(validPatterns, (pattern) => _.isEqual(pattern, currentPattern));
    console.log("isElseIfBlockPattern 2", {
        block,
        sourceType,
        validPatterns,
        currentPattern,
        isValid,
    });
    return isValid;
};
BLOCK_TYPES.isElseIfBlockPattern = isElseIfBlockPattern;
export default BLOCK_TYPES;
